module.exports = {
  i18n: {
    defaultLocale: 'en-US',
    locales: ['en-US', 'de', 'fr', 'es', 'it', 'pt', 'ja', 'nl', 'ko', 'ar'],
    localePath: './public/static/locales'
  },
}
